import { useState, useEffect } from 'react'; 
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText'; 
import Collapse from '@mui/material/Collapse'; 
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore'; 
import PublicIcon from '@mui/icons-material/Public'; 
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';  
import CircularProgress from '@mui/material/CircularProgress';  
import { get } from 'aws-amplify/api'; 

export default function QuotaList({user}) {      
    const [open, setOpen] = useState({
      Facebook: false, 
      Instagram: false,
      YouTube: false,
      Twitter: false,
      TikTok: false, 
    });
    const [team, setTeam] = useState("");
    const [quota, setQuota] = useState();
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {   
        const getTeam = async () => {
            try {
                const getOperation = get({ 
                    apiName: 'gccusermapapi',
                    path: '/gccusermap' 
                });
                const { body } = await getOperation.response;
                const json = await body.json(); 
                const username = user.username; 
                let team = ""; // Only to check if user-to-team mapping exists for current user
                json.forEach((obj) => { 
                  if (obj.username === username) { 
                    team = obj.team;  
                    setTeam(team); 
                    return;
                  }});
                if (team.length === 0) { 
                  console.log("User-to-team mapping for this user does not exist.");
                } 
            // console.log('GET call succeeded: ', json); 
            } catch (error) {
                console.log('GET call failed: ', error);
            }
        } 
        getTeam();    
    }, [user]);    
    
    useEffect(() => {     
        const getQuota = async () => {
            try {
                const getOperation = get({ 
                  apiName: 'gcctaskquotaapi',
                  path: '/gcctaskquota' 
                });
        const { body } = await getOperation.response;
        const json = await body.json();  
        let list = json.find(list => list.team === (team + "-quota")); 
        let current = json.find(list => list.team === (team + "-current"));
        console.log(current)
        let temp = {
            Facebook: {
              Account: [list.facebook_account, list.facebook_account - current.facebook_account],
              Hashtag: [list.facebook_hashtag, list.facebook_hashtag - current.facebook_hashtag],
              Keyword: [list.facebook_keyword, list.facebook_keyword - current.facebook_keyword]
            },
            Instagram: {
              Account: [list.instagram_account, list.instagram_account - current.instagram_account],
              Hashtag: [list.instagram_hashtag, list.instagram_hashtag - current.instagram_hashtag],
              Keyword: [list.instagram_keyword, list.instagram_keyword - current.instagram_keyword],
            },
            YouTube: {
              Account: [list.youtube_account, list.youtube_account - current.youtube_account],
              Hashtag: [list.youtube_hashtag, list.youtube_hashtag - current.youtube_hashtag],
              Keyword: [list.youtube_keyword, list.youtube_keyword - current.youtube_keyword]
            },
            Twitter: {
              Account: [list.twitter_account, list.twitter_account - current.twitter_account],
              Hashtag: [list.twitter_hashtag, list.twitter_hashtag - current.twitter_hashtag],
              Keyword: [list.twitter_keyword, list.twitter_keyword - current.twitter_keyword]
            },      
            TikTok: {
              Account: [list.tiktok_account, list.tiktok_account - current.tiktok_account],
              Hashtag: [list.tiktok_hashtag, list.tiktok_hashtag - current.tiktok_hashtag],
              Keyword: [list.tiktok_keyword, list.tiktok_keyword - current.tiktok_keyword]
            },
        }        
        setQuota(temp);  
        setLoading(false);
        console.log("Fetched quota list")
      } catch (error) {
        console.log('GET call for quota list failed: ', error);
      }
    } 
        if (team) {
            getQuota(); 
        }
    }, [team])
    
    // useEffect(() => {
    //     if (props.quota !== undefined) {
            // let temp = {
            //     Facebook: {
            //       Account: props.quota.facebook_account,
            //       Hashtag: props.quota.facebook_hashtag,
            //       Keyword: props.quota.facebook_keyword
            //     },
            //     Instagram: {
            //       Account: props.quota.instagram_account,
            //       Hashtag: props.quota.instagram_hashtag,
            //       Keyword: props.quota.instagram_keyword
            //     },
            //     YouTube: {
            //       Account: props.quota.youtube_account,
            //       Hashtag: props.quota.youtube_hashtag,
            //       Keyword: props.quota.youtube_keyword
            //     },
            //     Twitter: {
            //       Account: props.quota.twitter_account,
            //       Hashtag: props.quota.twitter_hashtag,
            //       Keyword: props.quota.twitter_keyword
            //     },      
            //     TikTok: {
            //       Account: props.quota.tiktok_account,
            //       Hashtag: props.quota.tiktok_hashtag,
            //       Keyword: props.quota.tiktok_keyword
            //     },
            // }
    //         setQuota(temp);
    //         setLoading(false);
    //     }
    // }, [props.quota])  
    
    const handleClick = (platform) => {
        // console.log(props.quota);
        let temp = {...open} 
        temp[platform] = !open[platform]; 
        setOpen(temp); 
    } 

    if (loading) {
      return <div className="loader">
        <CircularProgress color="inherit"/>
      </div> 
    }  
    
    return (
        <>
            <Divider component="li">
                <Typography sx={{color: "black" }} variant="h6" component="div">
                Quota
                </Typography>
            </Divider>
            <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
              component="nav"
              aria-labelledby="nested-list-subheader" 
            >    
                { Object.keys(quota).map((key, i) => {
                    return (
                        <span key={i}>
                        <ListItemButton onClick={() => handleClick(key)}>
                            <ListItemIcon>
                                <PublicIcon />
                            </ListItemIcon>
                            <ListItemText primary={key} primaryTypographyProps={{fontSize: '16px', color: 'black'}} />
                            {open[key] ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={open[key]} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                { Object.keys(quota[key]).map((type, index) => {
                                    return (
                                        <ListItem sx={{ pl: 4 }} key={index}>
                                            <ListItemText primary={type + ": " + quota[key][type][0] } secondary={" Remaining: " + quota[key][type][1]} primaryTypographyProps={{fontSize: '14px', color: 'black'}} />
                                        </ListItem>                        
                                    )
                                })}
                            </List>
                        </Collapse>
                        </span>
                    )
                })}
            </List> 
        </>
    );
} 